module.exports = __webpack_public_path__ + "media/meeting-is-being-recorded.1abcabec.mp3";